import { Suspense } from 'react';
import {
    DashboardContainer,
    PlansContainer,
    ProfileContainer,
    SimsContainer,
    SubAccountsContainer,
    UserManagementContainer,
    ZonesContainer,
    B2CUserContainer,
    B2CPlanContainer,
    B2CDiscountCodeContainer,
    B2CSalesContainer,
} from '@src/containers';
import * as URLS from '@src/constants/URLS.const';
import { Layout } from '@src/layout';
import { UsersList } from '@src/pages/UserManagement/Users';
import RolesList from '@src/pages/UserManagement/Roles/Roles.List';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import NewRole from '@src/pages/UserManagement/Roles/NewRole/NewRole';
import RolesDetailsPage from '@src/pages/UserManagement/Roles/RolesDetailsPage/RolesDetailsPage';
import { LogsList } from '@src/pages/UserManagement/Logs/Logs.List';
import { ProtectedRoute } from './ProtectedRoute';
import { MODULE_KEYS } from '@src/constants/permissions.const';

export function DashboardRoutes() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route
                    index
                    element={
                        <ProtectedRoute permissionKey={MODULE_KEYS.Dashboard}>
                            <Suspense fallback={null}>
                                <DashboardContainer />
                            </Suspense>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={`${URLS.SIMS_URL}/*`}
                    element={
                        <ProtectedRoute permissionKey={MODULE_KEYS.Sims}>
                            <Suspense fallback={null}>
                                <SimsContainer />
                            </Suspense>
                        </ProtectedRoute>
                    }
                />
                <Route path={`${URLS.PLAN_MANAGEMENT_URL}`}>
                    <Route
                        path={`${URLS.PLANS_URL}/*`}
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS['Plan_Management.Plans']
                                }
                            >
                                <Suspense fallback={null}>
                                    <PlansContainer />
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={URLS.ZONES_URL}
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS['Plan_Management.Zones']
                                }
                            >
                                <Suspense fallback={null}>
                                    <ZonesContainer />
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                </Route>
                <Route
                    path={`${URLS.SUB_ACCOUNTS_URL}/*`}
                    element={
                        <ProtectedRoute permissionKey={MODULE_KEYS.SubAccounts}>
                            <Suspense fallback={null}>
                                <SubAccountsContainer />
                            </Suspense>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={`${URLS.USER_MANAGEMENT_URL}/*`}
                    element={
                        <ProtectedRoute
                            permissionKey={MODULE_KEYS.UserManagement}
                        >
                            <Suspense fallback={null}>
                                <UserManagementContainer />
                            </Suspense>
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Navigate to="users" replace />} />

                    <Route
                        path="users"
                        element={
                            <ProtectedRoute
                                permissionKey={MODULE_KEYS.UserManagement}
                            >
                                <UsersList />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="roles"
                        element={
                            <ProtectedRoute
                                permissionKey={MODULE_KEYS.RoleManagement}
                            >
                                <Outlet />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<RolesList />} />
                        <Route path="new" element={<NewRole />} />
                        <Route path="edit/:roleId" element={<NewRole />} />
                        <Route
                            path=":roleId/details"
                            element={<RolesDetailsPage />}
                        />
                    </Route>
                    <Route
                        path="users-logs"
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS.ActivityLogManagement
                                }
                            >
                                <LogsList />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="*"
                        element={
                            <Navigate
                                to={`${URLS.USER_MANAGEMENT_FULL_URL}/users`}
                                replace
                            />
                        }
                    />
                </Route>
                <Route
                    path={URLS.PROFILE_URL}
                    element={
                        <Suspense fallback={null}>
                            <ProfileContainer />
                        </Suspense>
                    }
                />
                <Route path={`${URLS.B2C_MANAGEMENT_URL}`}>
                    <Route
                        path={`${URLS.B2C_USERS_URL}/*`}
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS['B2CManagement.Users']
                                }
                            >
                                <Suspense fallback={null}>
                                    <B2CUserContainer />
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={`${URLS.B2C_PLANS_URL}/*`}
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS['B2CManagement.Packages']
                                }
                            >
                                <Suspense fallback={null}>
                                    <B2CPlanContainer />
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={`${URLS.B2C_DISCOUNTCODE_URL}/*`}
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS['B2CManagement.Discounts']
                                }
                            >
                                <Suspense fallback={null}>
                                    <B2CDiscountCodeContainer />
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={`${URLS.B2C_SALES_URL}/*`}
                        element={
                            <ProtectedRoute
                                permissionKey={
                                    MODULE_KEYS['B2CManagement.Sales']
                                }
                            >
                                <Suspense fallback={null}>
                                    <B2CSalesContainer />
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                </Route>
            </Route>
        </Routes>
    );
}
